/* voyado-favorite.js
 * Forwards Wishlist King favourite toggles to the Elevate SDK so the Favorites
 * recommendation is fed from every surface — collection cards, search, sliders
 * and the PDP alike.
 *
 * Wishlist King dispatches these store-level events on every successful add/
 * remove, regardless of which button triggered it (including the detached
 * floating card button, which carries no product id of its own). The payload's
 * data.product.id is the Shopify product id — the Elevate product key in this
 * feed, the same value the PDP button and the recommendation sliders pass.
 *
 * Because the events fire on the operation lifecycle (not on page-load
 * hydration), there is no spurious-fire-on-load to guard against.
 *
 * The events are dispatched on `document` with bubbles:false — they do NOT
 * reach `window`, so these listeners MUST be on `document`.
 *
 * Notifications go through window.elevate.notify, which manages session keys and
 * consent internally (unlike voyado-atc.js, which gates consent manually).
 */

document.addEventListener("wk:wishlist:add:success", (e) => {
  const key = String(e.detail?.data?.product?.id ?? "");
  if (key) window.elevate?.notify?.addFavorite(key);
});

document.addEventListener("wk:wishlist:remove:success", (e) => {
  const key = String(e.detail?.data?.product?.id ?? "");
  if (key) window.elevate?.notify?.removeFavorite(key);
});
